"use client";
import { jsxs as d, jsx as o } from "react/jsx-runtime";
import r from "clsx";
import { memo as p, useId as b } from "react";
import '../../assets/Switch.css';const f = "_small_1fbke_5", u = "_normal_1fbke_12", h = "_large_1fbke_19", g = "__loading_1fbke_26", k = "__disabled_1fbke_30", w = "_input_1fbke_35", x = "_slider_1fbke_43", s = {
  switch: "_switch_1fbke_1",
  small: f,
  normal: u,
  large: h,
  _loading: g,
  _disabled: k,
  input: w,
  slider: x
}, y = p(
  ({ onClick: e, loading: _, disabled: t, size: i = "normal", extraClass: a, ...c }) => {
    const n = b(), m = (l) => {
      l.preventDefault(), l.stopPropagation(), !(_ || t) && (e == null || e(l));
    };
    return /* @__PURE__ */ d(
      "label",
      {
        htmlFor: n,
        className: r(
          s.switch,
          s[i],
          {
            [s._loading]: _,
            [s._disabled]: t
          },
          a
        ),
        onClick: m,
        children: [
          /* @__PURE__ */ o(
            "input",
            {
              id: n,
              type: "checkbox",
              className: s.input,
              readOnly: !0,
              ...c
            }
          ),
          /* @__PURE__ */ o(
            "span",
            {
              className: r(
                s.slider,
                {
                  [s._disabled]: t
                },
                a
              )
            }
          )
        ]
      }
    );
  }
);
y.displayName = "Switch";
export {
  y as Switch
};
